var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkdenIconBlackCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 237.39999 237.39999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #010202;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M118.70001-.00003C53.09998-.00003,0,53.10001,0,118.69998s53.09998,118.70001,118.70001,118.70001,118.70001-53.10004,118.70001-118.70001S184.20001-.00003,118.70001-.00003ZM87.72479,183.61728h-27.99396v-90.38574h27.99396v90.38574ZM73.5932,81.39627c-9.14447,0-16.5545-7.4682-16.5545-16.67883s7.41003-16.67877,16.5545-16.67877,16.55011,7.4682,16.55011,16.67877-7.40558,16.67883-16.55011,16.67883ZM192.61731,183.61728h-27.85718v-47.44696c0-13.00867-4.94299-20.27838-15.23938-20.27838-11.20111,0-17.05322,7.56525-17.05322,20.27838v47.44696h-26.8465v-90.38574h26.8465v12.17499s8.07202-14.9364,27.2525-14.9364c19.17169,0,32.89728,11.70734,32.89728,35.92053v57.22662Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkdenIconBlackCircle);
export default __webpack_public_path__ + "static/media/linkden-icon-black-circle.8e878e600146ceae0096503699bc1108.svg";
export { ForwardRef as ReactComponent };